import { DateTime } from "luxon";
import { Location } from "./locations";
import { ActionTypes, ObjectTypeEnum } from "../enums";

export class JobDetailsService {
    id?: string;
    action?: ActionTypes;
    product?: string;
    lcCode?: string;
    objectType?: ObjectTypeEnum;
    itemId?: string;
    description ? : string;
    size?: string;
    weight?: number;
    tenantId?: string;
    locationName?: string;
    locationId?: Location;
    createdAt?: DateTime;
    customData?: string;
    isChecked?: boolean;
}